<script>
import Banner from '../components/PageBanner';
import Modale from '../components/Modale';
import Spinner from '../components/Spinner';


export default {
  name: 'Test',
  components:{
      Banner,
      Modale,
      Spinner,
  },
  data(){
      return{
          file:"",
          isModaleVisible: false,
      }
  },
  methods:{
      onSelect(){
          this.file = this.$refs.file.files[0];
      },
      async onSubmit(){
          alert("j'essai d'envoyer...")
          const formData = new FormData();
          formData.append('file', this.file);
          this.$axios.post('/upload', formData)
            .then(response => (console.log(response)))
            .catch(e => (console.log(e)));
      },
      showModale(){
          this.isModaleVisible = true;
      },
      closeModale(){
          this.isModaleVisible = false;
      },
      exportPDF(){
            var pdfMake = require('pdfmake/build/pdfmake.js')
            if (pdfMake.vfs == undefined){
                var pdfFonts = require('pdfmake/build/vfs_fonts.js')
                pdfMake.vfs = pdfFonts.pdfMake.vfs;
            }
            var docDefinition = { content: 'This is an sample PDF printed with pdfMake' }
            pdfMake.createPdf(docDefinition).download('optionalName.pdf')
      },
      phaseToContractualise(){
        console.log("C'est parti !------------------------")
        //Que chaque projet ait un contrat
        // this.$axios.post('contrats/initialize').then(res => console.log(res.data.message)).catch(err => console.log(err))
        //Que chaque phase ait un contractualise
        // this.$axios.post('contractualise/init').then(res => console.log(res.data.message)).catch(err => console.log(err))
      },
  }
}
</script>


<template>
    <div class="page-main">
        <Banner bannerImage="bannerDebug" hasAvatar=0 />
        
        <h1>Test Uploads</h1>
        <form enctype="multipart/form-data" @submit.prevent="onSubmit()">
            <input type="file" ref="file" @change="onSelect"/>
            <button @click="onSubmit">Envoyer</button>
        </form>

        <h1>Test Spinner</h1>
        <Spinner />

        <h1>Test Modale</h1>
        <Modale v-if="isModaleVisible" @close="closeModale">
            <template v-slot:header>
                <span>Un test des transitions</span>
            </template>
            <template v-slot:body>
                <div>Ça marche avec l'élément posé brutalement</div>
                <div>Ça marche avec les slots</div>
            </template>
            <template v-slot:footer>
                
            </template>
        </Modale>
        <button @click="showModale">Show Modale</button>

        <h1>:nthChild(2n)</h1>
        <div class="parent">
            <div class="child">enfant</div>
            <div class="child">enfant</div>
            <div class="child">enfant</div>
            <div class="child">enfant</div>
        </div>

        <h1>Export PDF</h1>
        <button @click="exportPDF">export default</button>

        <h1>Montant des phases</h1>
        <p>Passer les montants de la table "phase" à la table "contractualise"</p>
        <button @click="phaseToContractualise">Go on !</button>

    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

@include page-main;

button{
    width: 200px;
}

h1{
    color: $mainColor;
    font-weight: 600;
}

.child{
    &:nth-child(2n){
        color: red;
    }
}

.child{
    &:nth-child(1){
        font-weight: 800;
    }
}
</style>
